import { getCompany } from '../../../utils/common';
import { companyInfo } from './Company';
import { exportProcessing } from './ExportProcessing';
export const handleExportRevenue = async (data) => {
	const company = getCompany();
	const comInfo = companyInfo[company] ? companyInfo[company] : [];

	return exportProcessing(data, comInfo);
};
